module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "is-top"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader",
    class: {
      'loader-more': _vm.loadOffset
    }
  }, [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "row"
  }, [(this.whichState === 'none') ? _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "map-header",
    class: {
      'loader-more': _vm.loadOffset
    }
  }, [_vm._v("The Water of the West")]) : _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    staticClass: "map-header",
    class: {
      'map-header-lower': _vm.loadOffset
    }
  }, [_vm._v("The Water of the West - " + _vm._s(_vm.fullState))]), _vm._v(" "), _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top"
  }, [_vm._v("\n      The western landscape is varied running from desert to rain forest.\n      However, most of the region tends towards aridness, requiring concentrated reservoirs and irrigation\n      to allow for large scale human settlement. The map and graph below shows the network of reservoirs across\n      the west.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-lg-6 map-graph"
  }, [_c('h3', [_vm._v("Reservoirs")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Percent Full for Month Ending (" + _vm._s(_vm.dateListing) + "), or Most Recently Available Month")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "map_legend"
    }
  }, [_c('svg', {
    attrs: {
      "width": "450",
      "height": "45",
      "transform": "translate(70,0)"
    }
  }, [_c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(26, 150, 65)"
    },
    attrs: {
      "x": "30",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "45",
      "y": "25",
      "height": "30",
      "width": "20"
    }
  }, [_vm._v("75%+")])]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(252, 232, 131)"
    },
    attrs: {
      "x": "100",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "115",
      "y": "25",
      "height": "30",
      "width": "20"
    }
  }, [_vm._v("50%+")])]), _vm._v(" "), _c('g', [_c('rect', {
    staticStyle: {
      "fill": "rgb(215, 25, 28)"
    },
    attrs: {
      "x": "165",
      "y": "15",
      "width": "10",
      "height": "10"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "180",
      "y": "25",
      "height": "30",
      "width": "40"
    }
  }, [_vm._v("Less than 50%")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "text-center upper"
  }, [_vm._v("Reservoir Capacity (acre feet)")]), _vm._v(" "), _c('circle-legend-chart', {
    attrs: {
      "dataValues": _vm.stations,
      "field": _vm.legend_field,
      "whichType": _vm.whichType
    }
  }), _vm._v(" "), _c('svg', {
    staticClass: "is-map",
    attrs: {
      "id": "map",
      "width": _vm.width,
      "height": _vm.height,
      "transform": _vm.offset
    }
  }, [_c('g', [_vm._l((_vm.stations), function(d, index) {
    return [_c('circle', {
      attrs: {
        "id": _vm.whichType + d.state + index,
        "cx": _vm.projection([d.lng, d.lat])[0],
        "cy": _vm.projection([d.lng, d.lat])[1],
        "fill": d.color,
        "r": _vm.scale(d.capacity)
      },
      on: {
        "click": function($event) {
          _vm.newRes(d)
        },
        "mouseover": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "mouseout": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        },
        "touchstart": function($event) {
          _vm.showItem(d, _vm.tipDiv, $event)
        },
        "touchend": function($event) {
          _vm.hideItem(d, _vm.tipDiv, $event)
        }
      }
    })]
  })], 2)])], 1), _vm._v(" "), _c('line-chart', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.done),
      expression: "done"
    }],
    attrs: {
      "whichState": _vm.whichState,
      "reservoirName": _vm.reservoirName,
      "selectedData": _vm.selectedData,
      "hasKey": _vm.hasKey
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "offset-sm-1 col-sm-10 offset-lg-1 col-lg-10 text-top text-next"
  }, [_vm._v("\n        Much of the American West has been in and out of drought for most of the 21"), _c('sup', [_vm._v("st")]), _vm._v(" century; leading\n      to lower average water levels than would be typical. For an example, check out reservoir levels in California\n      in 2015 and most of 2016.\n      Click a reservoir to display its levels. Hover over the graph to see the levels for a given month. Data\n        updated monthly; so feel free to check back often.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5770d22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 381
// module chunks = 1